import { v4 as uuid } from 'uuid';
import { type AnyExtension, generateHTML, generateJSON } from '@tiptap/react';

import { coreExtensions } from '../../extensions';

const ensureTrailingParagraph = (doc: any): any => {
  if (!doc || doc.type !== 'doc' || !Array.isArray(doc.content)) {
    return doc;
  }

  const content = [...doc.content];

  const last = content[content.length - 1];

  const isEmptyParagraph = last && last.type === 'paragraph' && (!last.content || last.content.length === 0);

  if (!isEmptyParagraph) {
    content.push({ type: 'paragraph' });
  }

  return { ...doc, content };
};

const addTocIds = (doc: any): any => {
  if (!doc || typeof doc !== 'object') return doc;

  const seen = new Set<string | null>();

  const walk = (node: any): any => {
    if (!node || typeof node !== 'object') return node;

    const content = Array.isArray(node.content) ? node.content.map(walk) : node.content;

    if (node.type === 'heading') {
      const attrs = node.attrs || {};

      let tocId: string | null = attrs['data-toc-id'] || attrs.id || null;

      if (!tocId || seen.has(tocId)) {
        tocId = uuid();
      }

      seen.add(tocId);

      return {
        ...node,
        attrs: {
          ...attrs,
          id: tocId,
          'data-toc-id': tocId,
        },
        content,
      };
    }

    return { ...node, content };
  };

  return walk(doc);
};

type toTiptapHtmlOptions = {
  ensureValidSchema?: boolean;
  extensions?: AnyExtension[];
};

export const toTiptapHtml = (html: string, options?: toTiptapHtmlOptions) => {
  const { ensureValidSchema = false, extensions = coreExtensions } = options || {};
  const json = generateJSON(html, extensions);

  if (ensureValidSchema) {
    const withTocIds = addTocIds(json);
    return generateHTML(ensureTrailingParagraph(withTocIds), extensions);
  }

  return generateHTML(json, extensions);
};
